module.exports = __webpack_public_path__ + "img/undraw_female_avatar_w3jk.ab625f7d.svg";